import { render, staticRenderFns } from "./ComPaging.vue?vue&type=template&id=7c9a0634"
import script from "./ComPaging.vue?vue&type=script&lang=js"
export * from "./ComPaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports